import styled from "styled-components";

export const MainDiv = styled.div`
  padding: 16px;
  width: 100%;
  max-width: 450px;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  border-radius: 5px;
  gap: 2px;
`;
export const SectionTitle = styled.p`
  margin: ${({ margin }) => margin && margin};
  color: #000;
  font-size: 14px;
  font-weight: 600;
`;
export const ClinicalScoreDiv = styled.div`
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
export const ClinicalScoreInfoDiv = styled.div`
  width: 90%;
  display: flex;
  align-items: center;
  border-radius: 4px;
  border: ${({ border }) => border && border};
  background-color: ${({ background }) => background && background};
`;
export const SectionTitleDiv = styled.div`
  padding: 10px;
  width: 164px;
`;
export const StatusDiv = styled.div`
  padding: 2px 8px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  background-color: ${({ background }) => background && background};
  gap: 4px;
`;
export const StatusText = styled.p`
  color: #fff;
  font-size: 10px;
  font-weight: 600;
`;
export const StatusImg = styled.img`
  width: 12px;
  height: 12px;
`;
export const OpenPopupButton = styled.button`
  height: fit-content;
  border: none;
  background: transparent;
  cursor: pointer;
  pointer-events: ${({ clickable }) => (clickable ? "auto" : "none")};
`;
export const OpenPopupImg = styled.img`
  width: 24px;
  height: 24px;
`;
